module.exports = __webpack_public_path__ + "img/prolongation-1.a8f55aa.png";